import { render, staticRenderFns } from "./NotificationsTopNav.vue?vue&type=template&id=3d3b863e"
import script from "./NotificationsTopNav.vue?vue&type=script&lang=js"
export * from "./NotificationsTopNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports